"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoWrapper = void 0;
/* eslint-disable import/prefer-default-export */
const styled_components_1 = __importDefault(require("styled-components"));
exports.VideoWrapper = styled_components_1.default.div `
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;

  & > iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
//# sourceMappingURL=styled.js.map